(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("moment"), require("React"), require("ReactDom"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "moment", "React", "ReactDom"], factory);
	else if(typeof exports === 'object')
		exports["MKUtils"] = factory(require("_"), require("moment"), require("React"), require("ReactDom"));
	else
		root["MKUtils"] = factory(root["_"], root["moment"], root["React"], root["ReactDom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 